import { loadRoutesLibrary } from "../../../../../helpers/googleMaps/GoogleMapsLoader";

const toLatLngLiteral = (point) => ({
  lat: Number(point.lat),
  lng: Number(point.lng),
});

const toWaypoint = (subRoute) => ({
  location: toLatLngLiteral(subRoute),
  stopover: true,
});

export const getRouteMetrics = async ({ origin, subRutes }) => {
  if (
    !Number.isFinite(Number(origin?.lat)) ||
    !Number.isFinite(Number(origin?.lng)) ||
    !subRutes?.length
  ) {
    return null;
  }

  const maps = await loadRoutesLibrary();
  const destination = subRutes[subRutes.length - 1];
  const waypoints = subRutes.slice(0, -1).map(toWaypoint);
  const directionsService = new maps.DirectionsService();

  const response = await directionsService.route({
    origin: toLatLngLiteral(origin),
    destination: toLatLngLiteral(destination),
    waypoints,
    travelMode: maps.TravelMode.DRIVING,
    optimizeWaypoints: false,
  });

  const route = response.routes?.[0];
  const legs = route?.legs || [];
  const distanceMeters = legs.reduce(
    (total, leg) => total + (leg.distance?.value || 0),
    0
  );
  const durationSeconds = legs.reduce(
    (total, leg) => total + (leg.duration?.value || 0),
    0
  );

  return {
    distanceKm: distanceMeters / 1000,
    durationMinutes: Math.ceil(durationSeconds / 60),
  };
};
